import { TrendingDown, TrendingUp } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

const TrendView = ({
  title = "",
  variant = "success",
  trendType = "up",
  noChange = false,
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center" sx={{ gridGap: "8px" }}>
      {!noChange && (
        <Box
          className={classes.trendView}
          sx={{
            color: (theme) => theme.palette[variant]?.main,
            backgroundColor: (theme) => theme.palette.background[variant],
          }}
        >
          {trendType === "up" ? <TrendingUp /> : <TrendingDown />}
        </Box>
      )}
      <Typography variant="body2">{title}</Typography>
    </Box>
  );
};

export default TrendView;
